import BROWSERS from './browsers.js'

const USER_AGENT_KEYWORDS_MAPPING = {
    CHROME: BROWSERS.CHROME,
    BRAVE: BROWSERS.BRAVE,
    CRIOS: BROWSERS.CHROME,
    EDGE: BROWSERS.EDGE,
    EDG: BROWSERS.EDGE,
    EDGIOS: BROWSERS.EDGE,
    FENNEC: BROWSERS.FIREFOX,
    MOZILLA: BROWSERS.FIREFOX,
    FXIOS: BROWSERS.FIREFOX,
    MSIE: BROWSERS.IE,
    OPERA: BROWSERS.OPERA,
    OPIOS: BROWSERS.OPERA,
    OPR: BROWSERS.OPERA,
    OPT: BROWSERS.OPERA,
    RV: BROWSERS.IE,
    SAFARI: BROWSERS.SAFARI,
    ARC: BROWSERS.ARC,
}

export default USER_AGENT_KEYWORDS_MAPPING
